import { render, staticRenderFns } from "./import-details-tree.vue?vue&type=template&id=496ef9f2&scoped=true&"
import script from "./import-details-tree.vue?vue&type=script&lang=js&"
export * from "./import-details-tree.vue?vue&type=script&lang=js&"
import style0 from "./import-details-tree.vue?vue&type=style&index=0&id=496ef9f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ef9f2",
  null
  
)

export default component.exports